import { Dispatch } from "redux";
import {JackpotPickBetsAction, JackpotPickBetsActionTypes} from "../../types/Jackpot/jackpotPickBetsTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const pickBetsJackpot = (type: string, events: any): any => {
    return async (dispatch: Dispatch<JackpotPickBetsAction>) => {
        try {
            dispatch({ type: JackpotPickBetsActionTypes.FETCH_JACKPOT_PICK_BETS_DATA });
            const response = await axios({
                method: 'post',
                url: `/api/jackpots/pick-bets?mode=${encodeURIComponent(type)}`,
                data:events,
                withCredentials: false
            });
            dispatch({ type: JackpotPickBetsActionTypes.FETCH_JACKPOT_PICK_BETS_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: JackpotPickBetsActionTypes.FETCH_JACKPOT_PICK_BETS_DATA_ERROR, payload: errorPayload });
        }
    }
}
